import { Params } from 'react-router-dom'
import * as swr__internal from 'swr/_internal'

export const IRTIS3_CACHE_STOP_KEY = 'irtis3.stops'
export const IRTIS3_CACHE_THEORETICAL_KEY = 'irtis3.theoretical'
export const IRTIS3_CACHE_OFFSET_KEY = 'irtis3.offset'

/**
 * Make sure to get the last stop entry since technically it's possible that a irtis3 screen is used for multiple stops.
 * We don't want to fallback to the previously used stop as cache.
 */
export function getLastSplitStopMapEntry(map: Map<string, unknown>) {
  for (const [key, value] of Array.from(map.entries()).reverse()) {
    // see useMultipleStops.hook.ts swr-key
    if (key.startsWith('stops-')) {
      return [key, value]
    }
  }
  return null
}

export function getTheoreticalPassages(map: Map<string, unknown>) {
  for (const [key, value] of Array.from(map.entries())) {
    if (key.startsWith('theoretical-')) {
      return [key, value]
    }
  }
  return null
}

export function localStorageProvider(
  _cache: Readonly<swr__internal.Cache>,
  urlPathParams: Readonly<Params>,
) {
  const [stopKey, stopValue] = JSON.parse(
    localStorage.getItem(IRTIS3_CACHE_STOP_KEY) || '[]',
  )
  const [theoreticalKey, theoreticalValue] = JSON.parse(
    localStorage.getItem(IRTIS3_CACHE_THEORETICAL_KEY) || '[]',
  )

  const map = new Map<string, unknown>()
  // only fill cache-object if url matches localStorage data
  if (stopKey && stopValue._k === `stops-${urlPathParams.haltenummers}`) {
    map.set(stopKey, stopValue)
  }
  // only fill cache-object if url matches localStorage data
  if (
    theoreticalKey &&
    theoreticalValue._k === `theoretical-${urlPathParams.haltenummers}`
  ) {
    map.set(theoreticalKey, theoreticalValue)
  }

  const storeLocaleStorageTimeout: NodeJS.Timeout = setTimeout(() => {
    const stop = getLastSplitStopMapEntry(map)
    const theoreticalPassages = getTheoreticalPassages(map)
    if (stop) {
      localStorage.setItem(IRTIS3_CACHE_STOP_KEY, JSON.stringify(stop))
      console.debug('Wrote stop cache to localStorage')
    }
    if (theoreticalPassages) {
      localStorage.setItem(
        IRTIS3_CACHE_THEORETICAL_KEY,
        JSON.stringify(theoreticalPassages),
      )
      console.debug('Wrote theoretical passages cache to localStorage')
    }
    return window.clearTimeout(storeLocaleStorageTimeout)
  }, 10_000)

  return map as swr__internal.Cache
}
